import React from 'react';
import { useParams } from 'react-router';

import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import { useToggle } from '@/src/hooks/useToggle';

import CreateFolder from '../../../Modal/CreateFolder/CreateFolder';

export const Add = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);

  return (
    <React.Fragment>
      <div className="filesUploadContainer">
        <a className="createFolderBtn" onClick={toggleIsModalOpen}>
          <i className="material-icons mr5">add</i>Create a folder
        </a>
      </div>
      {isModalOpen && (
        <ModalPortal>
          <CreateFolder projectId={projectId} onClose={() => toggleIsModalOpen(false)} />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};
